module.exports = __webpack_public_path__ + "static/media/icn_travel_covid_fisdom.db03678a.svg";